import { Dropdown, DropdownToggle,DropdownMenu, DropdownItem} from "reactstrap";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function ProductStatus({direction, ...args}) {
    const[searchParams, setSearchParams] = useSearchParams();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [status, setStatus] = useState(searchParams.get('product_status') || '');
    
    const toggle = () => setDropdownOpen((prevState) => !prevState);

    const handleChangestatus = (status) => {
        setStatus(status);
        searchParams.set('product_status', status);
        searchParams.delete('page');
        setSearchParams(searchParams);
    }
    
    useEffect(() => {
        setStatus(searchParams.get('product_status') || '');
    }, [searchParams])

  return (
    <>
        Status:
        <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={direction} className={`d-inline-block ms-2`}>
            <DropdownToggle caret outline size="sm" className={`text-capitalize`}>
                {!status ? 'All' : status}
            </DropdownToggle>
            <DropdownMenu {...args}>
                <DropdownItem onClick={(e) => handleChangestatus(e.target.value)} value={''} >All</DropdownItem>
                <DropdownItem onClick={(e) => handleChangestatus(e.target.value)} value={'new'} >New</DropdownItem>
                <DropdownItem onClick={(e) => handleChangestatus(e.target.value)} value={'old'} >Old</DropdownItem>
                <DropdownItem onClick={(e) => handleChangestatus(e.target.value)} value={'defective'} >Defective</DropdownItem>
            </DropdownMenu>
        </Dropdown>

    </>
  )
}
